import React, { useEffect, useState } from "react";
import Correct from "../../../../assets/icons/correct";
import { useMediaQuery } from "react-responsive";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { updateTrueandFalseAnswer, updateSelectedComponentType } from "../../../../redux/slices/userActivity";
import CorrectGreen from "../../../../assets/icons/correctGreen";
import { EditText } from "react-edit-text";
import Answer from "./answer";

const TandF = ({ styles, isTrueanswer }) => {
  const { modalOpen: previewModalOpen, showAnswers } = useSelector((state) => state.preview);

  const { selectedUserActivity } = useSelector((state) => state.userActivity);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      updateSelectedComponentType({
        type: "slide",
        name: "container",
      })
    );
  }, []);

  const handleClick = (e, bool) => {
    e.stopPropagation();
    dispatch(
      updateSelectedComponentType({
        type: "text",
        name: "answer",
      })
    );
    dispatch(updateTrueandFalseAnswer({ selectedActivityIdx: selectedUserActivity, answer: bool }));
  };

  const handleButtonClick = (e) => {
    e.stopPropagation();
    dispatch(
      updateSelectedComponentType({
        type: "button",
        name: "answer",
        hoverName: "answerHover",
      })
    );
  };

  const setTrue = () => {
    dispatch(updateTrueandFalseAnswer({ selectedActivityIdx: selectedUserActivity, answer: true }));
  };

  const setFalse = () => {
    dispatch(updateTrueandFalseAnswer({ selectedActivityIdx: selectedUserActivity, answer: false }));
  };

  let inputColor = "#000";
  if (styles.answer) {
    if (Object.keys(styles.answer).includes("color")) inputColor = styles.answer.color;
  }

  return (
    <div className="boxContainer row" style={{ ...styles.answerContainer, alignSelf: "stretch" }}>
      <Answer isTrue={true} setTrue={setTrue} setFalse={setFalse} styles={styles} handleClick={handleClick} handleButtonClick={handleButtonClick} isTrueanswer={isTrueanswer} inputColor={inputColor} />
      <Answer
        isTrue={false}
        setTrue={setTrue}
        setFalse={setFalse}
        styles={styles}
        handleClick={handleClick}
        handleButtonClick={handleButtonClick}
        isTrueanswer={isTrueanswer}
        inputColor={inputColor}
      />
    </div>
  );
};

export default TandF;
